document.addEventListener('DOMContentLoaded', function() {
  const productFeedTabs = document.querySelectorAll('product-feed');

  productFeedTabs.forEach(feedTab => {
    const navButtons = feedTab.querySelectorAll('.product__feed-tabs--nav-btn');
    const contentBoxes = feedTab.querySelectorAll('.product__feed-tabs--content-box');

    // Tab değiştirme
    navButtons.forEach(button => {
      button.addEventListener('click', function() {
        const targetId = this.getAttribute('data-target');

        navButtons.forEach(btn => btn.classList.remove('tabs--nav-btn-active'));
        this.classList.add('tabs--nav-btn-active');

        contentBoxes.forEach(box => {
          box.classList.toggle('tabs--content-active', box.id === targetId);
        });
        
        // Tab değiştiğinde renk hover'ı yeniden başlat
        initColorSwatchHovering(feedTab);
      });
    });
    
    // Sayfa yüklendiğinde renk hover'ı başlat
    initColorSwatchHovering(feedTab);
  });
  
  // Renk swatch hover fonksiyonu
  function initColorSwatchHovering(container) {
    const colorSwatches = container.querySelectorAll('.color-swatch--with-image');
    
    if (!colorSwatches.length) {
      return;
    }
    
    colorSwatches.forEach(swatch => {
      // Önceki event listener'ları temizle
      const newSwatch = swatch.cloneNode(true);
      swatch.parentNode.replaceChild(newSwatch, swatch);
      
      // Mouseenter event
      newSwatch.addEventListener('mouseenter', function() {
        const variantId = this.dataset.variantId;
        const variantImage = this.dataset.variantImage;
        
        if (variantId && variantImage) {
          const colorImageEl = container.querySelector('.grid-product__color-image--' + variantId);
          if (colorImageEl) {
            colorImageEl.style.backgroundImage = 'url(' + variantImage + ')';
            colorImageEl.classList.add('is-active');
          }
        }
      });
      
      // Mouseleave event
      newSwatch.addEventListener('mouseleave', function() {
        const variantId = this.dataset.variantId;
        
        if (variantId) {
          const colorImageEl = container.querySelector('.grid-product__color-image--' + variantId);
          if (colorImageEl) {
            colorImageEl.classList.remove('is-active');
          }
        }
      });
    });
  }
});
